import React from "react";
import {
  Panel,
  PanelType,
  PrimaryButton,
  DefaultButton,
  Checkbox,
} from "@fluentui/react";

export type UserStatusFilter = "all" | "active" | "inactive" | "unassigned";

interface Props {
  isOpen: boolean;
  onDismiss: () => void;
  selectedStatus: UserStatusFilter;
  onStatusChange: (status: UserStatusFilter) => void;
  onApplyFilters: () => void;
  onClearFilters: () => void;
}

const UsersFilterPanel: React.FC<Props> = ({
  isOpen,
  onDismiss,
  selectedStatus,
  onStatusChange,
  onApplyFilters,
  onClearFilters,
}) => {
  const handleApply = () => {
    onApplyFilters();
    onDismiss();
  };

  const handleClear = () => {
    onClearFilters();
    onDismiss();
  };

  const hasActiveFilters = selectedStatus !== "all";

  return (
    <Panel
      headerText="Filter Users"
      isOpen={isOpen}
      onDismiss={onDismiss}
      type={PanelType.smallFixedFar}
      closeButtonAriaLabel="Close filter panel"
      isLightDismiss={true}
    >
      <div style={{ padding: "20px 0" }}>
        <div style={{ marginBottom: "20px" }}>
          <h4 style={{ marginBottom: "10px", color: "#323130" }}>Status</h4>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <Checkbox
              label="All"
              checked={selectedStatus === "all"}
              onChange={() => onStatusChange("all")}
            />
            <Checkbox
              label="Active"
              checked={selectedStatus === "active"}
              onChange={() => onStatusChange("active")}
            />
            <Checkbox
              label="Inactive"
              checked={selectedStatus === "inactive"}
              onChange={() => onStatusChange("inactive")}
            />
            <Checkbox
              label="Unassigned"
              checked={selectedStatus === "unassigned"}
              onChange={() => onStatusChange("unassigned")}
            />
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gap: "8px",
            marginTop: "30px",
            paddingTop: "20px",
            borderTop: "1px solid #edebe9",
          }}
        >
          <PrimaryButton text="Apply Filters" onClick={handleApply} />
          <DefaultButton
            text="Clear All"
            onClick={handleClear}
            disabled={!hasActiveFilters}
          />
        </div>

        {hasActiveFilters && (
          <div
            style={{
              marginTop: "15px",
              fontSize: "12px",
              color: "#605e5c",
            }}
          >
            Active filters: 1 filter applied
          </div>
        )}
      </div>
    </Panel>
  );
};

export default UsersFilterPanel;
